import { CHAT_FILTERS } from '../constants/chatFilters';

/**
 * Проверяет, доступен ли фильтр для выбранной роли.
 * Один источник правды: роль. Пустой permissions: [] = роль "админ" = доступ ко всему.
 *
 * @param {string} filterKey - ключ фильтра (например, 'use_source_jira')
 * @param {Object} userRole - выбранная роль с полем permissions (массив)
 * @returns {boolean} - true если фильтр доступен
 */
export const isFilterAvailable = (filterKey, userRole) => {
  const filter = CHAT_FILTERS.find((f) => f.key === filterKey);
  if (!filter) return true;
  if (!filter.permission) return true;

  if (!userRole) return false;
  const perms = userRole.permissions;
  if (!Array.isArray(perms)) return false;
  // Пустой массив = роль "админ" = доступ ко всем источникам
  if (perms.length === 0) return true;

  return perms.some((p) => p.name === filter.permission);
};

/**
 * Оставляет в объекте фильтров только значения, доступные выбранной роли.
 * Недоступные обнуляются (чтобы в запрос к бэку не уходили лишние галочки).
 *
 * @param {Object} filters - объект с фильтрами
 * @param {Object} userRole - выбранная роль с полем permissions
 * @returns {Object} - отфильтрованный объект
 */
export const filterAvailableFilters = (filters, userRole) => {
  const filtered = { ...filters };

  Object.keys(filtered).forEach((key) => {
    if (key === 'show_specification_select' || key === 'context_mode') return;

    if (!isFilterAvailable(key, userRole)) {
      // Для use_specification устанавливаем null
      if (key === 'use_specification') {
        filtered[key] = null;
      }
      // Для массивов устанавливаем пустой массив
      else if (Array.isArray(filtered[key])) {
        filtered[key] = [];
      }
      // Для остальных булевых значений устанавливаем false
      else {
        filtered[key] = false;
      }
    }
  });

  // Дополнительная проверка для use_specification: если show_specification_select === false, обнуляем
  if (!filtered.show_specification_select) {
    filtered.use_specification = null;
  }

  return filtered;
};
